/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Length } from './Length';
import {
    LengthFromJSON,
    LengthFromJSONTyped,
    LengthToJSON,
} from './Length';
import type { PropertyValueHint } from './PropertyValueHint';
import {
    PropertyValueHintFromJSON,
    PropertyValueHintFromJSONTyped,
    PropertyValueHintToJSON,
} from './PropertyValueHint';
import type { SourceAxisDistanceMin } from './SourceAxisDistanceMin';
import {
    SourceAxisDistanceMinFromJSON,
    SourceAxisDistanceMinFromJSONTyped,
    SourceAxisDistanceMinToJSON,
} from './SourceAxisDistanceMin';

/**
 * 
 * @export
 * @interface SourceAxisDistance
 */
export interface SourceAxisDistance {
    /**
     * 
     * @type {Length}
     * @memberof SourceAxisDistance
     */
    defaultValue?: Length;
    /**
     * 
     * @type {string}
     * @memberof SourceAxisDistance
     */
    readonly displayUnit?: string | null;
    /**
     * 
     * @type {Length}
     * @memberof SourceAxisDistance
     */
    value?: Length;
    /**
     * 
     * @type {Array<Length>}
     * @memberof SourceAxisDistance
     */
    valuesContinued?: Array<Length> | null;
    /**
     * 
     * @type {string}
     * @memberof SourceAxisDistance
     */
    valueInfo?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourceAxisDistance
     */
    valueInfoParameters?: Array<string> | null;
    /**
     * 
     * @type {PropertyValueHint}
     * @memberof SourceAxisDistance
     */
    valueHint?: PropertyValueHint;
    /**
     * 
     * @type {boolean}
     * @memberof SourceAxisDistance
     */
    isRequired?: boolean;
    /**
     * 
     * @type {SourceAxisDistanceMin}
     * @memberof SourceAxisDistance
     */
    min?: SourceAxisDistanceMin | null;
    /**
     * 
     * @type {SourceAxisDistanceMin}
     * @memberof SourceAxisDistance
     */
    max?: SourceAxisDistanceMin | null;
    /**
     * 
     * @type {string}
     * @memberof SourceAxisDistance
     */
    $type?: SourceAxisDistanceTypeEnum;
}


/**
 * @export
 */
export const SourceAxisDistanceTypeEnum = {
    PtwDomainItemTypeCatalogInfrastructurePropertyTypesCommonDataTypeSourceAxisDistancePtwDomainItemTypeCatalogInfrastructure: 'Ptw.DomainItemTypeCatalog.Infrastructure.PropertyTypes.CommonDataType.SourceAxisDistance, Ptw.DomainItemTypeCatalog.Infrastructure'
} as const;
export type SourceAxisDistanceTypeEnum = typeof SourceAxisDistanceTypeEnum[keyof typeof SourceAxisDistanceTypeEnum];


/**
 * Check if a given object implements the SourceAxisDistance interface.
 */
export function instanceOfSourceAxisDistance(value?: unknown): value is SourceAxisDistance {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SourceAxisDistanceTypeEnum)[0];
}

export function SourceAxisDistanceFromJSON(json: any): SourceAxisDistance {
    return SourceAxisDistanceFromJSONTyped(json, false);
}

export function SourceAxisDistanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceAxisDistance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultValue': !exists(json, 'defaultValue') ? undefined : LengthFromJSON(json['defaultValue']),
        'displayUnit': !exists(json, 'displayUnit') ? undefined : json['displayUnit'],
        'value': !exists(json, 'value') ? undefined : LengthFromJSON(json['value']),
        'valuesContinued': !exists(json, 'valuesContinued') ? undefined : (json['valuesContinued'] === null ? null : (json['valuesContinued'] as Array<any>).map(LengthFromJSON)),
        'valueInfo': !exists(json, 'valueInfo') ? undefined : json['valueInfo'],
        'valueInfoParameters': !exists(json, 'valueInfoParameters') ? undefined : json['valueInfoParameters'],
        'valueHint': !exists(json, 'valueHint') ? undefined : PropertyValueHintFromJSON(json['valueHint']),
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'min': !exists(json, 'min') ? undefined : SourceAxisDistanceMinFromJSON(json['min']),
        'max': !exists(json, 'max') ? undefined : SourceAxisDistanceMinFromJSON(json['max']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function SourceAxisDistanceToJSON(value?: SourceAxisDistance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultValue': LengthToJSON(value.defaultValue),
        'value': LengthToJSON(value.value),
        'valuesContinued': value.valuesContinued === undefined ? undefined : (value.valuesContinued === null ? null : (value.valuesContinued as Array<any>).map(LengthToJSON)),
        'valueInfo': value.valueInfo,
        'valueInfoParameters': value.valueInfoParameters,
        'valueHint': PropertyValueHintToJSON(value.valueHint),
        'isRequired': value.isRequired,
        'min': SourceAxisDistanceMinToJSON(value.min),
        'max': SourceAxisDistanceMinToJSON(value.max),
        '$type': value.$type,
    });
}

